enum Actions {
	SET_ORDER_ROW = '[OrderRows] SET_ORDER_ROW',
	UPDATE_ORDER_ROW = '[OrderRows] UPDATE_ORDER_ROW',
	ORDER_INTERVAL_CHANGED = '[OrderRows] ORDER_INTERVAL_CHANGED'
}

export default Actions;
